import { initAnalytics } from "@/lib/analytics";
import { initJourneyStore } from "@/lib/journeyStore";

// Product analytics (PostHog) — pageviews, autocapture, session replay,
// feature flags, and exception capture. No key → no-op.
//
// Deferred to idle time. The dynamic import() inside initAnalytics() (see
// analytics.ts) already keeps posthog-js out of the critical bundle, but
// that alone doesn't delay WHEN it runs — called here directly, the fetch/
// parse/execute still starts immediately and a Lighthouse mobile audit
// showed its ~600ms of script evaluation barely dropped, since it was still
// contending with hydration for the same main thread. requestIdleCallback
// waits for the browser to actually be idle first; Safari has no
// requestIdleCallback, so it falls back to a short setTimeout. The `timeout`
// forces it to run within 2s regardless, so a busy page doesn't delay
// analytics indefinitely. track()'s own pending-events queue (analytics.ts)
// already tolerates an arbitrarily long delay here without dropping events.
if (typeof requestIdleCallback === "function") {
  requestIdleCallback(() => initAnalytics(), { timeout: 2000 });
} else {
  setTimeout(() => initAnalytics(), 1);
}

// Journey-progress store — scope the cache per signed-in user and sync it with
// the journey_progress table (hydrate on load, debounced upserts on write).
initJourneyStore();
